import Modal from "./Modal";
import HubspotForm from "react-hubspot-form";
import Menu from "./Menu";
import { NavLink } from "react-router-dom";

import "../css/header.css";

import image1 from "../img/utpl.png";

function Header() {
  return (
    <>
      <div className="wrapper-header">
        <div className="layout9">
          <div className="logo ">
   
            <div>
              <NavLink to="/">
                <img src={image1} alt="utpl" className="logo"></img>
              </NavLink>
            </div>
          </div>

          <div className="menu-items">
            <Menu></Menu>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
